/**
 * Created by claudio iozzia on 26/06/2017.
 */
import {Ic} from "../../../models/common";
import {Warning} from "../../../models/warning";
import {isNullOrUndefined} from "util";
import {ISingleOutput} from "../../../models/ISpec";
import {IAppSpec} from "../../../Redux/selector.state";
import {Utils, tassign} from "../../../common/utils";
import {UpdateDesign_DcDc_Buck, UpdateDesign_DcDc_BuckBoost} from "../../POWER/dcdc/update-design";
import {SPEC_VALUE_OUTPUTS_INIT} from "../../../models/Spec_States";


export class UpdateDesign_DcLED_Buck extends UpdateDesign_DcDc_Buck {

  protected updateDesign_SingleOutput(ic: Ic, spec: IAppSpec, out: ISingleOutput<number>, i: number): Ic {

    const _out: ISingleOutput<number> = (Utils.isValueEmpty(out.voltage) || Utils.isValueEmpty(out.current))
      ? SPEC_VALUE_OUTPUTS_INIT
      : spec.spec.value.output.globalOutput;

    const warning: Warning = this.Ton_i(ic, spec, _out);
    const _ic_warning = isNullOrUndefined(ic.warning)
      ? new Warning(warning.msg, warning.severity)
      : ic.warning.reset(warning.msg, warning.severity);

    return tassign(ic, {warning: _ic_warning});
  }

}

export class UpdateDesign_DcLED_BuckBoost extends UpdateDesign_DcLED_Buck {

  protected dutyCycle(ic: Ic, vin: number, vout: number, iout: number): number {
    return UpdateDesign_DcDc_BuckBoost.dutyCycle_BuckBoost(ic, vin, vout, iout);
  }

}
